import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import '../../../assets/css/customer/services/GallerySection.css';

const GallerySection = () => {
  // Gallery Images Data
  const galleryImages = [
    {
      id: 1,
      image: 'https://i.pinimg.com/736x/a0/55/cb/a055cb62d1ff3b355e60f46c71a53a4d.jpg',
      alt: 'Wedding Couple 1'
    },
    {
      id: 2,
      image: 'https://i.pinimg.com/1200x/89/f1/0e/89f10e11cf6d80d6efed5d54c0a1e97b.jpg',
      alt: 'Wedding Couple 2'
    },
    {
      id: 3,
      image: 'https://i.pinimg.com/1200x/6b/b4/32/6bb4327876b22da0421ec7db71b7eac0.jpg',
      alt: 'Wedding Couple 3'
    },
    {
      id: 4,
      image: 'https://i.pinimg.com/736x/4e/2a/90/4e2a90524e644f8f95784f3b805d06ae.jpg',
      alt: 'Wedding Bride 1'
    },
    {
      id: 5,
      image: 'https://i.pinimg.com/1200x/ed/a2/c2/eda2c2af95beccd0f7bd371a34bcf4e6.jpg',
      alt: 'Wedding Couple 4'
    },
    {
      id: 6,
      image: 'https://i.pinimg.com/736x/b2/1d/14/b21d147010e1691421bf6551ad45a564.jpg',
      alt: 'Wedding Couple 5'
    }
  ];

  return (
    <section className="gs-gallery-section">
      <Container>
        {/* Section Header */}
        <Row className="justify-content-center">
          <Col xs={12} lg={10} xl={8}>
            <div className="gs-gallery-header text-center">
              <p className="gs-gallery-subtitle">
                Unforgettable Events
              </p>
              <h2 className="gs-gallery-main-heading">
                Capturing Love and Celebration in Visual Showcase
              </h2>
            </div>
          </Col>
        </Row>

        {/* Gallery Grid */}
        <Row className="gs-gallery-grid g-4">
          {galleryImages.map((item) => (
            <Col 
              xs={12} 
              sm={6} 
              lg={4} 
              key={item.id}
              className="gs-gallery-col"
            >
              <div className="gs-gallery-card">
                <div className="gs-gallery-image-wrapper">
                  <img 
                    src={item.image} 
                    alt={item.alt}
                    className="gs-gallery-image"
                  />
                  <div className="gs-gallery-overlay">
                    <div className="gs-gallery-overlay-content">
                      <span className="gs-gallery-icon">🔍</span>
                    </div>
                  </div>
                </div>
              </div>
            </Col>
          ))}
        </Row>

        {/* Decorative Stripe (Bottom Left) */}
        <div className="gs-gallery-stripe-decoration"></div>
      </Container>
    </section>
  );
};

export default GallerySection;